module.exports = __webpack_public_path__ + "static/img/i-1.fd8b1c78.png";